export default __webpack_public_path__ + "img/email-variant.f5adaaeb.svg";